/* eslint indent: 0 */

import './media_library.choose_folder_modal.less';

import each from 'lodash/each';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import Backbone from 'backbone';
import chooseFolderModalTemplate from  './media_library.choose_folder_modal.tpl';
import userStore from 'zoomforth_zf/appglobals/user.js';


const ChooseFolderModal = Backbone.View.extend({
    // the add media view should not have any direct effects on 
    // its calling context during the course of its lifespan
    
    // it resolves its deferred with an asset or assets that have been directly selected,    
    className: 'folder-chooser-modal modal hide hasTitle',

    events: {
      'hidden': 'hidden',
      'click .action-select-folder': 'selectFolder',
      'click .action-expand': 'expandRow',
      'click .action-submit': 'submitModal'
    },

    initialize : function(options) {
      const disallowedFolderIds = options.folderCollection.getDisallowedFolderIdsForUser(
        {userModel: userStore.get()}
      );
      this.deferred = $.Deferred();
      // do not show folders whose assets are hidden to the user.
      // @TODO consider adding logic on the backend to prevent
      // the user from moving an asset to a private folder they cannot see.
      this.sortedFolders = filter(
        options.folderCollection.getSubtreeSortedByHierarchy(
          options.folderCollection.getRoot()
        ),
        (folder)=> {
          return !includes(disallowedFolderIds, folder.get('id'));
        }
      );
      this.folderId = null;
      this.selectedItemType = options.selectedItemType;
      this.selectedItemId = options.selectedItemId;
      this.navState = options.navState;
    },

    
    template: chooseFolderModalTemplate,
    
    render : function() {
      this.$el.html(this.template({
        view: this,
        folders: this.sortedFolders
      }));
      return this;
    },
    
    remove: function(){
      if(this.deferred.state() == 'pending'){
        this.deferred.reject();
      }
      ChooseFolderModal.__super__.remove.call(this);
    },
    
    hidden: function(){
      this.trigger('hidden');
      this.remove();
    },
    
    show: function(options) {      
      this.render().$el.modal({
        width: '500px'
      });
      return this.deferred.promise();
    },
    
    selectFolder: function(e){
      var $target = $(e.currentTarget);
      this.$('.selected').removeClass('selected');
      const folderIdAttr = $target.attr('data-folder-id');

      if (!folderIdAttr){
        this.folderId = null;
      } else {
        this.folderId = parseInt(folderIdAttr);
      }
      if(this.folderId != this.selectedItemId) {
        $target.addClass('selected');
        this.$('.action-submit').show();
      }
    },
    
    expandRow: function(e) {
      e.stopPropagation();
      var $target = $(e.currentTarget);
      var folderToExpand = $target.parent().attr('data-folder-id');
      var indentLevel = parseInt($target.parent().attr('indent'));
      var allFolders = this.$el.find('.folder-choice');
      var parentIds;
      each(allFolders, function(folder) {
        parentIds = $(folder).attr('data-parent-ids');
        if(parentIds.indexOf(folderToExpand) > -1 && parseInt($(folder).attr('indent')) == indentLevel+1) {
          $(folder).toggleClass('hide');
        }
      });
      $target.parent().toggleClass('expanded');
    },
    
    shouldShowAsCurrentLocation: function(folder){
      if (this.navState.getIsSearching()){
        return false;
      }
      return this.navState.get('folder_id') == folder.get('id') && this.selectedItemType == "asset";
    },
    
    submitModal: function(){
      this.deferred.resolve(this.folderId);
      this.$el.modal('hide');
    }
    
  });

  
export default ChooseFolderModal;
